// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CapsuleBoard_wrapper__3EWHJ"};